<template>
  <form class="dropzone">
    <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
    <div id="dropzone-message" style="display: none">
      <span class="dropzone-title">Drop files here or click to select</span>
      <span class="dropzone-info">You can upload multiple files at once</span>
    </div>

    <div class="previews"></div>
    <div class="clickable"></div>
  </form>
</template>

<script>
import Dropzone from 'dropzone';
import './dropzone.css';

Dropzone.autoDiscover = false;

export default {
  props: ['filesystemId', 'directoryId'],
  methods: {
    getSignedUrl(file, then) {
      var url = appUrls.files.get_presigned_upload_url.replace('REPLACEME', this.filesystemId);

      axios.put(url, {
        "type": file.type,
        "size": file.size,
        "fullPath": file.fullPath,
        'directory_id': this.directoryId,
        "name": file.name
      }).then(function (response) {
        then(response.data.data);
      });

    }
  },
  mounted() {
    const vm = this;

    let options = {
      // The URL will be changed for each new file being processing
      url: 'http://127.0.0.1',

      // Since we're going to do a `PUT` upload to S3 directly
      method: 'POST',

      previewsContainer: ".previews",
      clickable: ".clickable",

      timeout:180000,
      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',

      // Customize the wording
      dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      // Here we request a signed upload URL when a file being accepted
      accept(file, done) {
        vm.getSignedUrl(file, function (response) {
          file.internal_name = response.internal_name;
          file.uploadURL = response._links.upload.url;
          file.uploadInputs = response._links.upload.inputs;
          file.success_url = response._links.success;

          done();
          // Manually process each file
          setTimeout(() => vm.dropzone.processFile(file));
        });
      },
      renameFile: function (file) {
        return file.internal_name;
      },
      success: function (file) {
        axios.put(file.success_url);
      },
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending(file, xhr, formData) {
        _.forEach(file.uploadInputs, function (value, key) {
          formData.append(key, value);
        });
      },
    }

    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, options)

    // Set signed upload URL for each file
    vm.dropzone.on('processing', (file) => {
      vm.dropzone.options.url = file.uploadURL
    })

    vm.dropzone.on('dragleave', () => {
      eventBus.$emit('dropzone-event-dragleave');
    });

    vm.dropzone.on('dragend', () => {
      eventBus.$emit('dropzone-event-dragend');
    });

    vm.dropzone.on('drop', () => {
      eventBus.$emit('dropzone-event-drop');
    });

    vm.dropzone.on('dragenter', () => {
      eventBus.$emit('dropzone-event-dragenter');
    });

    vm.dropzone.on('queuecomplete', () => {
      eventBus.$emit('dropzone-event-queuecomplete');
    });

  }
}
</script>

<style lang="scss" scoped>

.dropzone {
  border-radius: $standardBorderRadius;
  border-color: #ddd;
}

.clickable {
  margin: -20px;
  height: 300px;
}
</style>
